'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = require('prop-types');

var _reactRouter = require('react-router');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _consumeProps = require('recompose-scope/consumeProps');

var _consumeProps2 = _interopRequireDefault(_consumeProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _exposeHandlers = require('recompose-scope/exposeHandlers');

var _exposeHandlers2 = _interopRequireDefault(_exposeHandlers);

var _exposeNamespace = require('recompose-scope/exposeNamespace');

var _exposeNamespace2 = _interopRequireDefault(_exposeNamespace);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gotoDocList = function gotoDocList(_ref) {
  var view = _ref.view,
      history = _ref.history;
  return function () {
    return history.push('/search/' + view);
  };
};
var gotoUpdateDoc = function gotoUpdateDoc(_ref2) {
  var view = _ref2.view,
      history = _ref2.history;
  return function (id) {
    return history.push('/edit/' + view + '/' + id);
  };
};
var gotoCreateDoc = function gotoCreateDoc(_ref3) {
  var view = _ref3.view,
      history = _ref3.history;
  return function () {
    return history.push('/edit/' + view + '/create');
  };
};
var gotoCopyDoc = function gotoCopyDoc(_ref4) {
  var view = _ref4.view,
      history = _ref4.history;
  return function () {
    return history.push('/edit/' + view + '/copy');
  };
};
var replaceDocId = function replaceDocId(_ref5) {
  var view = _ref5.view,
      history = _ref5.history;
  return function (id) {
    return history.replace('/edit/' + view + '/' + id);
  };
};

function matchUrlToParams(url) {
  return (0, _reactRouter.matchPath)(url, { path: '/search/:view' }) || (0, _reactRouter.matchPath)(url, { path: '/edit/:view/:id' });
}

// consume React Router input props, expose route params and handlers
var enhancer = (0, _composeWithScope2.default)((0, _consumeProps2.default)({
  location: _propTypes.object,
  history: _propTypes.object.isRequired,
  match: (0, _propTypes.shape)({
    url: _propTypes.string.isRequired
  }),
  staticContext: _propTypes.any }), (0, _exposeProps2.default)(function (_ref6) {
  var url = _ref6.match.url;

  // match url again to handle custom route
  var _matchUrlToParams = matchUrlToParams(url),
      _matchUrlToParams$par = _matchUrlToParams.params,
      view = _matchUrlToParams$par.view,
      id = _matchUrlToParams$par.id;

  // route: /edit/:view/:id
  // create path: /edit/:view/create
  // copy path: /edit/:view/copy
  // update path: /edit/:view/:id


  var _ref7 = id === 'create' || id === 'copy' ? [id, null] : ['update', id],
      _ref8 = _slicedToArray(_ref7, 2),
      editType = _ref8[0],
      docId = _ref8[1];

  return {
    view: view,
    docId: docId,
    editType: editType
  };
}), (0, _exposeHandlers2.default)({
  gotoDocList: gotoDocList,
  gotoUpdateDoc: gotoUpdateDoc,
  gotoCreateDoc: gotoCreateDoc,
  gotoCopyDoc: gotoCopyDoc,
  replaceDocId: replaceDocId
}), (0, _exposeNamespace2.default)('page'));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'providePage');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/enhancers/connectServer/providePage.js
// module id = 1117
// module chunks = 0